import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { endTutorial, setEndTutorialPopup } from '../actions/tutorial';
import { restartTutorial, getTutorialStatus, changeTutorialStatus, resetTimer } from '../actions/init';
import { connect } from 'react-redux';
import TutorialEndScreen from '../components/tutorialEndScreen';

class TutorialEnd extends Component {
    componentDidMount() {
        if (this.props.tutorial.tutorialStatus === -1) {
            getTutorialStatus();
            setEndTutorialPopup(false);
        }
        this.props.resetTimer()
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.tutorial.tutorialStatus !== 1) {
            changeTutorialStatus({
                status: 1
            })
        }
    }

    render() {
        const welcomeStyle = {
            width: '100%',
            boxSizing: 'border-box',
            height: '100%',
            position: 'relative',

        };

        return (
            <div style={welcomeStyle} >
                <TutorialEndScreen
                    {...this.props}
                    endTutorial={endTutorial}
                    restartTutorial={restartTutorial}
                    logoutType={this.props.uiState.user.logoutType}
                    introductionData={this.props.uiState.introductionData}
                />
            </div >
        )
    }
}

const mapStatetoProps = (state) => {
    return state;
};

export default connect(mapStatetoProps, { resetTimer })(TutorialEnd);



// WEBPACK FOOTER //
// /src/containers/TutorialEndContainer.js